export default "__VITE_ASSET__BV$quw8O__"